import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ShufflerService {
  shuffleArrayBasedOnId(array: string[], id?: string): string[] {
    const allNumbersRegEx = /^\d+$/;
    const otherReason = array.findIndex((reason) => reason === 'Other');
    let other: string[] = [];

    // keep other at the end
    if (otherReason !== -1) {
      other = [array.splice(otherReason, 1)[0]];
    }

    if (!id) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]];
      }
      return [...array, ...other];
    }

    if (!allNumbersRegEx.test(id)) {
      throw new Error('ID must contain only numeric digits');
    }

    const seed = parseInt(id, 10);
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(this.seededElement(seed) * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  private seededElement(seed: number): number {
    const x = Math.sin(seed++) * 10000;
    return x - Math.floor(x);
  }
}
